module.exports = __webpack_public_path__ + "img/2025-03-11-01-02.7dc96374.png";